import { render, staticRenderFns } from "./previewImages.vue?vue&type=template&id=6062b1be&scoped=true&"
import script from "./previewImages.vue?vue&type=script&lang=js&"
export * from "./previewImages.vue?vue&type=script&lang=js&"
import style0 from "./previewImages.vue?vue&type=style&index=0&id=6062b1be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062b1be",
  null
  
)

export default component.exports